import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import Article from "@/pages/article/page";
import Spreadsheet from "@/pages/spreadsheet/page";
import Guides from "@/pages/guides/page";
import Reviews from "@/pages/reviews/page";
import Safety from "@/pages/safety/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/article/:slug",
    element: <Article />,
  },
  {
    path: "/spreadsheet",
    element: <Spreadsheet />,
  },
  {
    path: "/guides",
    element: <Guides />,
  },
  {
    path: "/reviews",
    element: <Reviews />,
  },
  {
    path: "/safety",
    element: <Safety />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;